import initialState from './initial-state'
import * as ACTIONS from 'constant/actions/customer-management'
import * as ROUTES from 'constant/routes'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.CUSTOMER_MANAGEMENT_SHOW_MODAL:
      state = {
        ...state,
        modalContent: action.modalContent,
        modalShowing: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_LIST + '_PENDING':
      state = {
        ...state,
        refreshCustomers: false,
        customerListLoading: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_LIST + '_REJECTED':
      state = {
        ...state,
        customerListLoading: false
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_LIST + '_FULFILLED':
      if (action.payload.data.success) {
        let cimn = 0;
        let showingSection = "";
        const pathnameSplit = window.location.pathname.split("/");
        if (window.location.pathname.startsWith(`${ROUTES.CUSTOMER_MANAGEMENT}/`)) {
          console.log(pathnameSplit, "path names");
        const cimnArr = Object.keys(action.payload.data.customers).filter(
          (customer) => action.payload.data.customers[customer].CICode === pathnameSplit[2]
        );
          if (cimnArr.length > 0) {
            cimn = cimnArr[0];
          }
          if (pathnameSplit.length > 3) {
            showingSection = `/${pathnameSplit[3]}`;
          }
        }

        state = {
          ...state,
          customerListLoading: false,
          customerList: action.payload.data.customers,
          selectedCustomer: cimn === 0 ? state.selectedCustomer : cimn,
          showingCustomerList: cimn === 0,
          showingSection: showingSection,
        };
      } else {
        state = {
          ...state,
          customerListLoading: false
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_SET_SELECTED_CUSTOMER:
      state = {
        ...state,
        showingCustomerList: action.cimn === 0,
        selectedCustomer: action.cimn,
        showingSection: ''
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_SET_SHOWING_SECTION:
      state = {
        ...state,
        showingSection: action.route
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_USERS + '_PENDING':
      state = {
        ...state,
        refreshUsers: false,
        loadingCustomerUsers: !state.refreshUsers,
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_USERS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingCustomerUsers: false,
          customerUsers: {
            ...state.customerUsers,
            [action.payload.data.cimn]: action.payload.data.customerUsers
          }
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_DISABLE_USER + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshUsers: true
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_STATISTICS + '_PENDING':
      state = {
        ...state,
        loadingCustomerStatistics: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_CUSTOMER_STATISTICS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingCustomerStatistics: false,
          customerStatistics: {
            ...state.customerStatistics,
            [action.payload.data.cimn]: action.payload.data.customerStatistics
          }
        }
      } else {
        state = {
          ...state,
          loadingCustomerStatistics: false
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_USER_COUNT + '_PENDING':
      state = {
        ...state,
        loadingGetUserCount: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_GET_USER_COUNT + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingGetUserCount: false,
          customerUserCount: {
            ...state.customerUserCount,
            [action.payload.data.cimn]: action.payload.data.customerUserCount
          }
        }
      } else {
        state = {
          ...state,
          loadingGetUserCount: false
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_UPDATE_USER_PROGRAM_VERSION + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshUsers: true
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_UPDATE_ALL_USER_PROGRAM_VERSIONS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          refreshUsers: true
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_REQUEST_CUSTOMER_REMOTE_CONNECTIONS_LIST + '_PENDING':
      state = {
        ...state,
        refreshRemoteConnections: false,
        loadingRemoteConnections: true,
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_REQUEST_CUSTOMER_REMOTE_CONNECTIONS_LIST + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingRemoteConnections: false,
          remoteConnections: {
            ...state.remoteConnections,
            [action.payload.data.cimn]: action.payload.data.connections
          }
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_REQUEST_CUSTOMER_REMOTE_CONNECTIONS_LIST_SILENTLY + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingRemoteConnections: false,
          remoteConnectionsStateChange: !state.remoteConnectionsStateChange,
          remoteConnections: {
            ...state.remoteConnections,
            [action.payload.data.cimn]: action.payload.data.connections
          }
        }
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_ADD_CUSTOMER + '_FULFILLED':
      state = {
        ...state,
        refreshCustomers: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_DELETE_CUSTOMER + '_FULFILLED':
      state = {
        ...state,
        refreshCustomers: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_ADD_REMOTE_CONNECTION + '_FULFILLED':
      state = {
        ...state,
        refreshRemoteConnections: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_UPDATE_USER_VERSION + '_FULFILLED':
      const {cpmn, version} = action.payload.data;
      const [v, value] = version.split("=");
      const selectedCustomer = state.selectedCustomer;
      const customerUsers = state.customerUsers[selectedCustomer].map(user => {
        if(user.CPMN == cpmn){
          return {...user, [v]: value == 0 ? false : true}
        }
        return user;
      });
      state = {
        ...state,
        customerUsers: {
          [state.selectedCustomer]: customerUsers
        }
        // refreshRemoteConnections: true
      }
      break
    case ACTIONS.CUSTOMER_MANAGEMENT_TOGGLE_CUSTOMER_LIST:
      state = {
        ...state,
        showingCustomerList: !state.showingCustomerList
      }
  }
  return state
}
